// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-l_hk","advertDetailHeaderLocation__value":"c-l_hl"};